import { JSX } from 'react';
import { InView } from 'react-intersection-observer';
import { KibButtonNew } from '@chewy/kib-controls-react';

export default function Ask({
  link,
  onSectionView,
  onLinkClicked,
  analytics,
}: {
  link: {
    text: string;
    url: string;
    analytics: {
      label: string;
      value: string;
    };
  };
  analytics: {
    label: string;
    value: string;
  };
  onSectionView: (
    label: string,
    value: string,
    extraData?: Record<string, string>,
  ) => void;
  onLinkClicked: (
    label: string,
    value: string,
    extraData: Record<string, string>,
  ) => void;
}): JSX.Element {
  return (
    <section className="pi-careplus__ask">
      <div className="pi-careplus__ask--content">
        <h2 className="pi-careplus__ask--title">Have Questions?</h2>
        <p className="pi-careplus__ask--text">
          We have a dedicated team of experts here to help 24/7.
        </p>
        <InView
          as="div"
          triggerOnce={true}
          onChange={(inView: any) => {
            if (!inView) return;
            onSectionView(analytics.label, analytics.value, { url: link.url });
          }}
          className="pi-careplus__ask--action"
        >
          <KibButtonNew
            onClick={() => {
              onLinkClicked(link.analytics.label, link.analytics.value, {
                url: link.url,
              });
            }}
            href={link.url}
            size="large"
          >
            {link.text}
          </KibButtonNew>
        </InView>
      </div>
    </section>
  );
}
